module.exports = __webpack_public_path__ + "img/instruction_2.d15523b6.svg";